import { Button } from "@/shared/components/ui/button";
import { Card, CardContent } from "@/shared/components/ui/card";
import { LucideIcon } from "lucide-react";

interface ActionCardProps {
  title: string;
  description: string;
  buttonText: string;
  icon?: LucideIcon;
  iconSrc?: string;
  variant: "primary" | "secondary" | "accent";
  onClick?: () => void;
}

export function ActionCard({ 
  title, 
  description, 
  buttonText, 
  icon: Icon, 
  iconSrc,
  variant,
  onClick 
}: ActionCardProps) {
  const getCardClasses = () => {
    switch (variant) {
      case "primary":
        return "bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20";
      case "secondary":
        return "bg-gradient-to-br from-secondary/10 to-secondary/5 border-secondary/20";
      case "accent":
        return "bg-gradient-to-br from-accent/10 to-accent/5 border-accent/20";
      default:
        return "bg-card";
    }
  };

  const getButtonVariant = () => {
    switch (variant) {
      case "primary":
        return "default";
      case "secondary":
        return "secondary";
      case "accent":
        return "accent";
      default:
        return "default";
    }
  };

  return (
    <Card 
      className={`${getCardClasses()} h-full hover:shadow-lg transition-all duration-200 cursor-pointer`}
      onClick={onClick}
    >
      <CardContent className="p-3 md:p-6 flex flex-col items-center text-center space-y-2 md:space-y-4 h-full">
        <div className="p-2 md:p-3 rounded-full bg-background/50">
          {iconSrc ? (
            <img src={iconSrc} alt="" className="h-6 w-6 md:h-8 md:w-8" />
          ) : Icon ? (
            <Icon className="h-6 w-6 md:h-8 md:w-8 text-foreground" />
          ) : null}
        </div>
        
        <div className="space-y-1 md:space-y-2 flex-1">
          <h3 className="text-sm md:text-xl font-semibold text-foreground">{title}</h3>
          <p className="text-muted-foreground text-xs md:text-sm">{description}</p>
        </div>
        
        <Button 
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          variant={getButtonVariant()}
          className="w-full font-medium text-xs md:text-sm py-1 md:py-2"
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
}